const state = {
    isLoading: false,
};

const mutations = {
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
};
const actions = {
    async setLoading({commit}, isLoading) {
        await new Promise(resolve => setTimeout(resolve, 200));
        commit('setLoading', isLoading);
    },
};

const getters = {
    isLoading: state => state.isLoading,
};

const loading = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default loading;